import { render, staticRenderFns } from "./IconUnnecessary.vue?vue&type=template&id=1c5cfb13&"
import script from "./IconUnnecessary.vue?vue&type=script&lang=js&"
export * from "./IconUnnecessary.vue?vue&type=script&lang=js&"
import style0 from "./IconUnnecessary.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports